import React, { useState, useEffect } from "react";
import DetailsPanel from "./DetailsPanel";
import Image from "react-bootstrap/Image";
import classNames from "classnames";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styles from "./DetailsPanel.module.scss";
import * as Yup from "yup";
import ExpertAssignList from "./ExpertAssignList"; // adjust path
import {
  Formik,
  Field,
  FieldArray,
  Form as FormikForm,
  ErrorMessage,
} from "formik";
import {
  createExpertise,
  updateFullExpertise,
  getSingleExpertise,
  updateExpertise,
  updateImages,
  updateAssignment,
} from "../../services/expertiseService";
import { useAlert } from "../../contexts/AlertContext";
import { updateUser } from "../../services/userService";
import ImagePreviewLightbox from "../ImagePreviewLightbox";

const ExpertiseDetailsPanel = ({
  onClose,
  item,
  setSelectedItem,
  date,
  isOpen,
  appendExpertiseList,
  deleteExpertiseFunc,
  setShowModal,
  expertUsers,
  fetchExpertise,
}) => {
  console.log("isOpen", isOpen);
  console.log("item", item);
  // alert(item?.id)
  // const [noSubCategory, setNoSubCategory] = useState(true);
  const [showExpertAssign, setShowExpertAssign] = useState(false);
  const [isAddingSubExpertise, setIsAddingSubExpertise] = useState(false);
  const [subExpertIndex, setSubExpertIndex] = useState(null);
  const { showAlert } = useAlert();
  const [singleExpertiseInformation, setSingleExpertiseInformation] =
    useState(item);
  const [expertiseData, setExpertiseData] = useState(null);
  const [productLogo, setProductLogo] = useState("/images/photo.png");
  const [showModalReset, setShowModalReset] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [initialSubExpValues, setInitialSubExpValues] = useState(null);
  const [storedExpertisePayload, setStoredExpertisePayload] = useState(null);

  function buildInitialValues(item) {
    // setProductLogo(item?.images?.[0] ?? "/images/photo.png");
    console.log("settingValue", item?.expertiseAssign);
    return {
      id: item?.id ?? "",
      name: item?.name ?? "",
      date: item?.date || new Date(),
      image: item?.images?.[0] || item?.image,
      expertiseAssign:
        item?.expertiseAssign?.map((assign) => ({
          id: assign?.user?.id || assign?.id || "",
          profilePic: assign?.user?.profilePic || assign?.profilePic || "",
          firstName: assign?.user?.firstName || assign?.firstName || "",
          lastName: assign?.user?.lastName || assign?.lastName || "",
        })) ?? [],
      children:
        item?.children?.map((child) => ({
          id: child?.id ?? "",
          name: child?.name ?? "",
          image: child?.images?.[0] ?? "",
          expertiseAssign:
            child?.expertiseAssign?.map((assign) => ({
              id: assign.user?.id ?? "",
              profilePic: assign.user?.profilePic ?? "",
              firstName: assign.user?.firstName ?? "",
              lastName: assign.user?.lastName ?? "",
            })) ?? [],
        })) ?? [],
    };
  }

  const updateUserAssignment = async (id, userList) => {
    console.log(id);
    console.log(userList?.expertiseAssign.map((elem) => elem.id));
    const listOfUsers = userList?.expertiseAssign.map((elem) => elem.id);
    try {
      const singleExpertiseData = await updateAssignment(id, {
        userIDs: listOfUsers,
      });

      showAlert({
        title: "Routing Notification",
        message: singleExpertiseData?.message ?? "something went wrong",
        variant: "success",
      });
      fetchExpertise();
      // const singleExpData= await fetchExpertiseById(id);

      // appendExpertiseList(singleExpData, singleExpertiseInformation?.id)
    } catch (error) {
      console.error("Error saving user:", error);
      showAlert({
        title: "Routing Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
      return;
    }
  };

  const fetchExpertiseById = async (id) => {
    try {
      // const singleExpertiseData = await getSingleExpertise(id);
      setExpertiseData(item);
      console.log("initialExpertiseData", item);
      const initial = buildInitialValues(item);
      console.log("initial", initial);
      setInitialValues(initial);
      setSingleExpertiseInformation({ ...item });
      // setProductLogo(initial?.image ?? 'asd')
      return item;
    } catch (error) {
      console.error("Error saving user:", error);
      showAlert({
        title: "Routing Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
      return;
    }
  };

  const resetExpertiseMainFields = (setFieldValue) => {
    setFieldValue("expertiseAssign", []);
    setFieldValue("children", []);
    setShowExpertAssign(false);
    setIsAddingSubExpertise(false);
    setSubExpertIndex(null);
  };

  useEffect(() => {
    setInitialValues(null);
    setInitialSubExpValues({
      values: buildInitialValues(null),
      formKey: new Date(),
    });

    // alert();
    if (item?.id) {
      fetchExpertiseById(item?.id);
    } else {
      setExpertiseData(null);
      setSingleExpertiseInformation(null);
      const initial = buildInitialValues(null);
      // setProductLogo(initial?.image);
      console.log("initial", initial);
      setInitialValues(initial);
    }
    setIsAddingSubExpertise(false);
    // setInitialSubExpValues(buildInitialValues(null));
    setInitialSubExpValues({
      values: buildInitialValues(null),
      formKey: new Date(),
    });
    setShowExpertAssign(false);

  }, [item]);

  const selecteSubExpertise = (index) => {
    // console.log("subExpertise",subExpertise)

    setSubExpertIndex(index);
    setIsAddingSubExpertise(true);
  };

  const childSchema = Yup.object({
    id: Yup.string(),
    name: Yup.string().required("Sub-expertise name is required"),
    images: Yup.array().nullable(),
    expertiseAssign: Yup.array(),
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Expertise Name is Required"),
    image: Yup.mixed().nullable(),
    expertiseAssign: Yup.array().of(
      Yup.object().shape({
        id: Yup.string(),
      })
    ),
    children: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().nullable(),
        name: Yup.string().trim().required("Sub Expertise Name is Required"),
        image: Yup.mixed().nullable(),
        expertiseAssign: Yup.array().of(
          Yup.object().shape({
            id: Yup.string(),
          })
        ),
      })
    ),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Validate that at least one expert is assigned
      const mainAssigned = values.expertiseAssign?.length > 0;
      const hasSubAssigned = values.children?.some(
        (child) => child.expertiseAssign?.length > 0
      );

      if (!mainAssigned && !hasSubAssigned) {
        showAlert({
          title: "Routing Notification",
          message:
            "Please assign at least one expert to either main expertise or sub-expertise." ??
            "something went wrong",
          variant: "danger",
        });
        setSubmitting(false);
        return;
      }

      const formData = new FormData();
      const { children, expertiseAssign, imageDisplay, image, ...rest } = values;
      formData.append("removeImage", 0);

      const transformedMain = {
        ...rest,
        members: (expertiseAssign || [])
          .map((item) => item?.id)
          .filter((id) => isValidUUID(id)) // Only keep UUIDs
      };

      // Transform children
      const transformedChildren = (children || []).map((child, index) => {
        const { image, imageDisplay, expertiseAssign, ...childRest } = child;
        const members = (expertiseAssign || [])
          .map((item) => item?.id)
          .filter((id) => isValidUUID(id));

        const removeImage = 0;

        if (image instanceof File) {
          formData.append(`subexpertise[${index}].sub_images`, image);
        }

        return {
          ...childRest,
          removeImage,
          members,
        };
      });

      Object.entries(transformedMain).forEach(([key, value]) => {
        formData.append(
          key,
          typeof value === "object" ? JSON.stringify(value) : value
        );
      });

      formData.append("subexpertise", JSON.stringify(transformedChildren));

      if (image instanceof File) {
        formData.append("images", image);
      }
    
      for (const [key, value] of formData.entries()) {
        console.log(key, value);
      }

      let singleExpertiseData;
      try {
        if (values?.id) {
          console.log("updating expertise -------------------------------------->", values);
          singleExpertiseData = await updateFullExpertise(values?.id, formData);
        } else {
          singleExpertiseData = await createExpertise(formData);
        }

        if (singleExpertiseData?.error?.length > 0) {
          showAlert({
            title: "Routing Notification",
            message: singleExpertiseData?.message ?? "something went wrong",
            variant: "danger",
          });
        } else {
          console.log("response", singleExpertiseData);
          appendExpertiseList(singleExpertiseData.data);
          showAlert({
            title: "Routing Notification",
            message: singleExpertiseData?.message ?? "something went wrong",
            variant: "success",
          });
        }
      } catch (error) {
        console.error("Error saving user:", error);
        showAlert({
          title: "Routing Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
        return;
      }
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };
  const isValidUUID = (id) => {
    const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return regex.test(id);
  };


  const resetExpertiseVButtonClicked = (values, setFieldValue) => {
    // Check if main expertise has assigned members

    if (values.expertiseAssign && values.expertiseAssign.length > 0) {
      // 1. Clear main expertise assigned experts
      setFieldValue("expertiseAssign", []);
      const newIndex = values.children.length;
      // 2. Add a new empty sub-expertise object
      const newSubExpertise = {
        name: "",
        expertiseAssign: [],
        image: null,
      };
      setShowExpertAssign(false);
      setSubExpertIndex(newIndex);
      setIsAddingSubExpertise(true);
      // Append to children
      setFieldValue("children", [...values.children, newSubExpertise]);
    }
  };

  const resetState = (values, setFieldValue) => {
    const children = [...values.children];
    const current = children[subExpertIndex];
    const isNewSubExpertise =
      !current?.id && // not saved yet
      (!current?.name?.trim() || current?.name?.trim() === "") && // name is empty or only whitespace
      (!Array.isArray(current?.expertiseAssign) ||
        current.expertiseAssign.length === 0) &&
      !current?.image &&
      !current?.imageDisplay;

    const isPartiallyFilled =
      !current?.id &&
      (current?.name?.trim() ||
        current?.expertiseAssign?.length > 0 ||
        current?.image ||
        current?.imageDisplay);

    // 👉 Remove if it's new AND either empty or partially filled but not completed
    if (isNewSubExpertise || isPartiallyFilled) {
      children.splice(subExpertIndex, 1);
      setFieldValue("children", children);
    } else {
      // Revert back to original if it existed before
      setFieldValue(
        `children.${subExpertIndex}`,
        initialValues?.children?.[subExpertIndex]
      );
    }

    setSubExpertIndex(null);
    setIsAddingSubExpertise(false);
  };
  return (
    <DetailsPanel key={expertiseData?.id} isOpen={!!isOpen && !!item}>
      {console.log("initialValuesView", initialValues)}
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          isValid,
          dirty,
          resetForm,
          handleChange,
          setFieldValue,
          validateForm,
          setTouched,
          isSubmitting,
          handleSubmit,
        }) => (

          <Form noValidate onSubmit={handleSubmit}>
            {!isAddingSubExpertise ? (
              <>
                <div
                  className={classNames(
                    styles["detail-panel-head"],
                    "d-flex align-items-center justify-content-between gap-3"
                  )}
                >
                  <h2 className="h5 fw-semibold mb-0">
                    {item?.id ? "Edit Expertise" : "Add Expertise"}
                  </h2>
                  <button
                    type="button"
                    className="btn-reset"
                    onClick={() => {
                      onClose();
                      resetState(values, setFieldValue);
                    }}
                  >
                    <Image src="/images/btn-close-square.svg" />
                  </button>
                </div>
                <div className={styles["detail-panel-body"]}>
                  <div className="d-flex align-items-center gap-4">
                    <ImagePreviewLightbox
                      className={styles["user-image"]}
                      src={
                        values?.imageDisplay ||
                        values?.image ||
                        "/images/photo.png"
                      }
                    >
                      <Image
                        className="w-100 h-100 object-fit-cover"
                        // src={(initialValues?.image)? initialValues?.image:productLogo}
                        src={
                          values?.imageDisplay ||
                          values?.image ||
                          "/images/photo.png"
                        }
                      />
                    </ImagePreviewLightbox>

                    <div className="btn-file">
                      <input
                        type="file"
                        id="btn-file-input"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFieldValue("image", file);
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setFieldValue("imageDisplay", reader.result); // <-- preview
                              // changeProductLogo(reader.result, file, values?.id); // optional
                            };
                            reader.readAsDataURL(file);
                          }
                          e.target.value = "";
                        }}
                      />

                      <label
                        htmlFor="btn-file-input"
                        className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
                      >
                        <Image
                          src={
                            values?.imageDisplay || values?.image
                              ? "/images/edit.svg"
                              : "/images/plus-black.svg"
                          }
                          width={16}
                          height={16}
                          alt="Plus Black Icon"
                        />{" "}
                        {values?.imageDisplay || values?.image ? "Edit" : "Add"}{" "}
                        Photo
                      </label>
                    </div>
                  </div>
                  <Form.Group className="mt-4" controlId="expertise">
                    <Form.Label className="required">Expertise Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={values?.name}
                      onChange={handleChange}
                      isInvalid={touched?.name && errors?.name}
                      placeholder="Enter expertise"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                  <FieldArray name="children">
                    {({ push, remove }) => {
                      return (
                        <>
                          {!showExpertAssign && !(values?.expertiseAssign?.length == 0 &&
                            values?.children?.length > 0) && (
                              <div className="border-top pt-4 mt-4">
                                <h4 className="text-blue fs-7 fw-medium mb-4">
                                  Want To Add Sub Expertise Name?
                                </h4>
                                <div className="d-flex align-items-center gap-3">
                                  {/* {values?.expertiseAssign?.length == 0 &&
                                  values?.children?.length > 0 && (
                                    <>
                                      <Button
                                        onClick={async () => {
                                          const formErrors =
                                            await validateForm();

                                          if (
                                            Object.keys(formErrors).length === 0
                                          ) {
                                            const newIndex =
                                              values.children.length;
                                            push({
                                              id: null,
                                              name: "",
                                              image: null,
                                              expertiseAssign: [],
                                            });
                                            setSubExpertIndex(newIndex);
                                            setIsAddingSubExpertise(true);
                                          } else {
                                            // Set all fields as touched so errors show
                                            const allTouched = {};
                                            const touchAllFields = (
                                              obj,
                                              path = ""
                                            ) => {
                                              Object.entries(obj).forEach(
                                                ([key, val]) => {
                                                  const currentPath = path
                                                    ? `${path}.${key}`
                                                    : key;
                                                  if (
                                                    typeof val === "object" &&
                                                    val !== null
                                                  ) {
                                                    touchAllFields(
                                                      val,
                                                      currentPath
                                                    );
                                                  } else {
                                                    allTouched[
                                                      currentPath
                                                    ] = true;
                                                  }
                                                }
                                              );
                                            };
                                            touchAllFields(formErrors);
                                            setTouched(allTouched);
                                          }
                                        }}
                                        className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                      >
                                        <Image
                                          src="/images/check-white.svg"
                                          width={16}
                                          height={16}
                                          alt="Back Arrow"
                                        />
                                        Yes, Sure
                                      </Button>

                                      <Button
                                        variant="outline-secondary"
                                        name="yesAddSubExpertiseButton"
                                        className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                        onClick={() =>
                                          resetExpertiseMainFields(
                                            setFieldValue
                                          )
                                        }
                                        // onClick={()=>alert("reset subexp")}
                                      >
                                        reset btn
                                      </Button>
                                    </>
                                  )} */}
                                  {values?.expertiseAssign?.length == 0 &&
                                    values?.children?.length == 0 && (
                                      <>
                                        <Button
                                          onClick={async () => {
                                            const formErrors =
                                              await validateForm();

                                            if (
                                              Object.keys(formErrors).length === 0
                                            ) {
                                              const newIndex =
                                                values.children.length;
                                              push({
                                                id: null,
                                                name: "",
                                                image: null,
                                                expertiseAssign: [],
                                              });
                                              setSubExpertIndex(newIndex);
                                              setIsAddingSubExpertise(true);
                                            } else {
                                              // Set all fields as touched so errors show
                                              const allTouched = {};
                                              const touchAllFields = (
                                                obj,
                                                path = ""
                                              ) => {
                                                Object.entries(obj).forEach(
                                                  ([key, val]) => {
                                                    const currentPath = path
                                                      ? `${path}.${key}`
                                                      : key;
                                                    if (
                                                      typeof val === "object" &&
                                                      val !== null
                                                    ) {
                                                      touchAllFields(
                                                        val,
                                                        currentPath
                                                      );
                                                    } else {
                                                      allTouched[
                                                        currentPath
                                                      ] = true;
                                                    }
                                                  }
                                                );
                                              };
                                              touchAllFields(formErrors);
                                              setTouched(allTouched);
                                            }
                                          }}
                                          className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                        >
                                          <Image
                                            src="/images/check-white.svg"
                                            width={16}
                                            height={16}
                                            alt="Back Arrow"
                                          />
                                          Yes, Sure
                                        </Button>

                                        <Button
                                          variant="outline-secondary"
                                          name="yesAddSubExpertiseButton"
                                          className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                          onClick={async () => {
                                            const formErrors =
                                              await validateForm();

                                            if (
                                              Object.keys(formErrors).length === 0
                                            ) {
                                              setShowExpertAssign(true);
                                            } else {
                                              // Set all fields as touched so errors show
                                              const allTouched = {};
                                              const touchAllFields = (
                                                obj,
                                                path = ""
                                              ) => {
                                                Object.entries(obj).forEach(
                                                  ([key, val]) => {
                                                    const currentPath = path
                                                      ? `${path}.${key}`
                                                      : key;
                                                    if (
                                                      typeof val === "object" &&
                                                      val !== null
                                                    ) {
                                                      touchAllFields(
                                                        val,
                                                        currentPath
                                                      );
                                                    } else {
                                                      allTouched[
                                                        currentPath
                                                      ] = true;
                                                    }
                                                  }
                                                );
                                              };
                                              touchAllFields(formErrors);
                                              setTouched(allTouched);
                                            }
                                          }}
                                        >
                                          No, Not Yet
                                        </Button>
                                      </>
                                    )}
                                  {values?.expertiseAssign?.length > 0 &&
                                    values?.children?.length == 0 && (
                                      <>
                                        <Button
                                          onClick={() =>
                                            resetExpertiseVButtonClicked(
                                              values,
                                              setFieldValue
                                            )
                                          }
                                          className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                        >
                                          <Image
                                            src="/images/check-white.svg"
                                            width={16}
                                            height={16}
                                            alt="Back Arrow"
                                          />
                                          Yes, Sure
                                        </Button>

                                        <Button
                                          variant="outline-secondary"
                                          name="yesAddSubExpertiseButton"
                                          className="btn btn-md w-100 d-flex align-items-center justify-content-center gap-2"
                                        >
                                          No, Not Yet
                                        </Button>
                                      </>
                                    )}
                                </div>
                                <ErrorMessage
                                  name="expertiseAssign"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            )}
                        </>
                      );
                    }}
                  </FieldArray>

                  {console.log("initialValues1111", values)}
                  {values?.children?.length > 0 && (
                    <div className="border-top pt-4 mt-4">
                      <h4 className="text-blue fs-7 fw-medium mb-4">
                        Sub Expertise
                      </h4>
                      <div className="expertise-list mt-3">
                        <FieldArray name="children">
                          {({ push, remove }) => {
                            return (
                              <>
                                <div className="expertise-item">
                                  <Button
                                    variant="dashed-primary"
                                    className="btn fs-7 fw-500 w-100 d-flex align-items-center justify-content-center gap-2"
                                    name="yesAddSubExpertiseButton"
                                    onClick={async () => {
                                      const formErrors = await validateForm();

                                      if (
                                        Object.keys(formErrors).length === 0
                                      ) {
                                        const newIndex = values.children.length;
                                        push({
                                          id: null,
                                          name: "",
                                          image: null,
                                          expertiseAssign: [],
                                        });
                                        setSubExpertIndex(newIndex);
                                        setIsAddingSubExpertise(true);
                                      } else {
                                        // Set all fields as touched so errors show
                                        const allTouched = {};
                                        const touchAllFields = (
                                          obj,
                                          path = ""
                                        ) => {
                                          Object.entries(obj).forEach(
                                            ([key, val]) => {
                                              const currentPath = path
                                                ? `${path}.${key}`
                                                : key;
                                              if (
                                                typeof val === "object" &&
                                                val !== null
                                              ) {
                                                touchAllFields(
                                                  val,
                                                  currentPath
                                                );
                                              } else {
                                                allTouched[currentPath] = true;
                                              }
                                            }
                                          );
                                        };
                                        touchAllFields(formErrors);
                                        setTouched(allTouched);
                                      }
                                    }}
                                  >
                                    <Image
                                      src="/images/plus-primary.svg"
                                      width={20}
                                      height={20}
                                      alt="Product Logo"
                                    />
                                    Add Sub Expertise
                                  </Button>
                                </div>

                                {values?.children?.map(
                                  (subExpertise, index) => {
                                    return (
                                      <div className="expertise-item d-flex align-items-center gap-3">
                                        <div className="d-flex align-items-center gap-2">
                                          <ImagePreviewLightbox
                                            className="product-icon"
                                            src={
                                              subExpertise?.images?.[0] ||
                                              subExpertise?.image ||
                                              "/images/product-icon.png"
                                            }
                                          >
                                            <Image
                                              className="object-fit-cover rounded-pill"
                                              src={
                                                subExpertise?.imageDisplay ||
                                                subExpertise?.images?.[0] ||
                                                subExpertise?.image ||
                                                "/images/product-icon.png"
                                              }
                                              width={48}
                                              height={48}
                                              alt="Product Logo"
                                            />
                                          </ImagePreviewLightbox>
                                          <span className="fs-6 fw-500">
                                            {subExpertise?.name}
                                          </span>
                                        </div>
                                        <div className="d-flex alig-items-center justify-content-center gap-1">
                                          <button
                                            type="button"
                                            className="btn btn-icon"
                                            onClick={() =>
                                              selecteSubExpertise(index)
                                            }
                                            aria-label="Edit Item"
                                          >
                                            <Image
                                              src="/images/edit.svg"
                                              width={20}
                                              height={20}
                                              alt="Pencil Icon"
                                            />
                                          </button>
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              // remove(index);
                                              if (subExpertise?.id) {
                                                remove(index);
                                                // setShowModal(subExpertise?.id);
                                              } else {
                                                remove(index);
                                              }
                                            }}
                                            // onClick={(e)=>deleteExpertiseFunc(subExpertise?.id)}
                                            className="btn btn-icon"
                                            aria-label="Delete Item"
                                          >
                                            <Image
                                              src="/images/trash.svg"
                                              alt="Delete Icon"
                                            />
                                          </button>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </>
                            );
                          }}
                        </FieldArray>
                      </div>
                    </div>
                  )}
                  {(showExpertAssign ||
                    values?.expertiseAssign?.length > 0 || values?.children?.length == 0) && (
                      <>
                        {/* <h4 className="text-blue fs-7 fw-medium mb-4">Assign Experts</h4> */}
                        {/* Inside your Formik render method */}
                        <div className="border-top pt-4 mt-4">
                          <h4 className="text-blue fs-7 fw-medium mb-4">
                            Assign Experts
                          </h4>
                          <ExpertAssignList
                            experts={expertUsers}
                            assignedExperts={values?.expertiseAssign}
                            setFieldValue={setFieldValue}
                            fieldName="expertiseAssign"
                          />
                        </div>
                      </>
                    )}
                </div>

                <div className={`${styles["detail-panel-footer"]} d-inline-flex w-100 justify-content-between gap-3`}>
                  <Button
                    type="submit"
                    className="btn btn-md d-flex align-items-center justify-content-center gap-2"
                    disabled={
                      isSubmitting ||
                      (!values?.expertiseAssign.length &&
                        !values?.children.length)
                      || !(dirty && isValid)
                    }
                  >
                    {values?.id ? "Save & Update" : "Save & Add"}
                  </Button>
                  {values?.expertiseAssign?.length == 0 &&
                    values?.children?.length > 0 && <Button
                      variant="outline-secondary"
                      name="yesAddSubExpertiseButton"
                      className="btn btn-md d-flex align-items-center justify-content-center gap-2"
                      onClick={() =>
                        resetExpertiseMainFields(
                          setFieldValue
                        )
                      }
                    // onClick={()=>alert("reset subexp")}
                    >
                      Reset
                    </Button>}

                </div>
              </>
            ) : (
              <>
                <div
                  className={classNames(
                    styles["detail-panel-head"],
                    "d-flex align-items-center justify-content-between gap-3"
                  )}
                >
                  <div className="d-flex align-items-center gap-3">
                    <Button
                      className="btn btn-sm d-flex align-items-center gap-1"
                      variant="outline-secondary"
                      onClick={() => {
                        resetForm();
                        setIsAddingSubExpertise(false);
                      }}
                    >
                      <Image
                        src="/images/caret-left.svg"
                        width={16}
                        height={16}
                        alt="Back Arrow"
                      />
                      Back
                    </Button>

                    <h2 className="h5 fw-semibold mb-0">
                      {item?.id && values?.children[subExpertIndex]?.id
                        ? "Edit Sub Expertise"
                        : "Add Sub Expertise"}
                    </h2>
                  </div>

                  <button
                    type="button"
                    className="btn-reset"
                    onClick={() => {
                      onClose();
                      resetState(values, setFieldValue);
                    }}
                  >
                    <Image src="/images/btn-close-square.svg" />
                  </button>
                </div>

                <div className={styles["detail-panel-body"]}>
                  <div className="d-flex align-items-center gap-4">
                    <ImagePreviewLightbox
                      className={styles["user-image"]}
                      src={
                        values?.children[subExpertIndex]?.imageDisplay ||
                        values?.children[subExpertIndex]?.image ||
                        "/images/photo.png"
                      }
                    >
                      <Image
                        className="object-fit-cover bg-gray-100 rounded-pill"
                        src={
                          (values?.children &&
                            values?.children[subExpertIndex]?.imageDisplay) ||
                          (values?.children &&
                            values?.children[subExpertIndex]?.image) ||
                          "/images/photo.png"
                        }
                      />
                    </ImagePreviewLightbox>
                    <div className="btn-file">
                      <input
                        name="btn-file-input2"
                        type="file"
                        id="btn-file-input2"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            // setFieldValue("image", file);
                            setFieldValue(
                              `children[${subExpertIndex}].image`,
                              file
                            );
                            const reader1 = new FileReader();
                            reader1.onloadend = () => {
                              setFieldValue(
                                `children[${subExpertIndex}].imageDisplay`,
                                reader1.result
                              );
                              // changeProductLogo(reader.result, file, values?.id); // optional
                            };
                            reader1.readAsDataURL(file);
                          }
                          e.target.value = "";

                        }}
                      />
                      <label
                        htmlFor="btn-file-input2"
                        className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
                      >
                        <Image
                          src="/images/plus-black.svg"
                          width={16}
                          height={16}
                          alt="Plus Black Icon"
                        />{" "}
                        {values?.children[subExpertIndex]?.imageDisplay ||
                          values?.children[subExpertIndex]?.image
                          ? "Edit"
                          : "Add"}{" "}
                        Photo
                      </label>
                    </div>
                  </div>

                  <Form.Group className="mt-4" controlId="sub-expertise">
                    <Form.Label>Sub Expertise Name</Form.Label>
                    <Form.Control
                      type="text"
                      name={`children[${subExpertIndex}].name`} // ✅ correct name path
                      value={values?.children[subExpertIndex]?.name || ""}
                      onChange={(e) => {
                        console.log(values);
                        console.log(e.target);
                        handleChange(e);
                      }}
                      isInvalid={
                        !!errors?.children?.[subExpertIndex]?.name &&
                        touched?.children?.[subExpertIndex]?.name
                      }
                      placeholder="Enter Sub Expertise Name"
                    />
                  </Form.Group>

                  {/* Inside your Formik render method */}
                  <div className="border-top pt-4 mt-4">
                    <h4 className="text-blue fs-7 fw-medium mb-4">
                      Assign Experts
                    </h4>
                    <ExpertAssignList
                      experts={expertUsers}
                      assignedExperts={
                        values?.children[subExpertIndex]?.expertiseAssign
                      }
                      setFieldValue={setFieldValue}
                      fieldName={`children[${subExpertIndex}].expertiseAssign`}
                    />
                  </div>
                </div>

                <div className={styles["detail-panel-footer"]}>
                  <Button
                    className="btn btn-md d-flex align-items-center justify-content-center gap-2"
                    disabled={
                      !values?.children?.[subExpertIndex]?.name?.trim() ||
                      !Array.isArray(
                        values?.children?.[subExpertIndex]?.expertiseAssign
                      ) ||
                      values?.children?.[subExpertIndex]?.expertiseAssign
                        ?.length === 0
                    }
                    onClick={() => {
                      const name =
                        values?.children?.[subExpertIndex]?.name?.trim();
                      const assigned =
                        values?.children?.[subExpertIndex]?.expertiseAssign ??
                        [];

                      if (!name) {
                        showAlert({
                          title: "Validation Error",
                          message: "Sub Expertise name is required.",
                          variant: "danger",
                        });
                        return;
                      }

                      if (!Array.isArray(assigned) || assigned.length === 0) {
                        showAlert({
                          title: "Validation Error",
                          message:
                            "Please assign at least one expert to this Sub Expertise.",
                          variant: "danger",
                        });
                        return;
                      }

                      // ✅ Valid – proceed
                      setIsAddingSubExpertise(false);
                    }}
                  >
                    {values?.children?.[subExpertIndex]?.id
                      ? "Save & Update"
                      : "Save & Add"}
                  </Button>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
      {/* old code below */}

      <Modal
        className="info-modal"
        show={showModalReset}
        onHide={() => setShowModalReset(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/refresh-badge-green.svg" alt="Refresh Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to reset?
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Any sub expertise created or assigned experts will be remove & set
              to default.
            </p>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => {
                  resetState();
                  setShowModalReset(false);
                }}
              >
                Yes, Reset Now!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModalReset(false)}
              >
                No, Don't Reset
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </DetailsPanel>
  );
};

export default ExpertiseDetailsPanel;
